module.exports = "/_next/static/images/556dc4f3c02d30ef6e7332d3642d52d9-sparkles-purple.svg.webp";